export default __webpack_public_path__ + "static/media/rekgpt_slogan_footer.b4785bca.svg";